import {RootDynamicComponentHelper} from "@shared/helpers/root-dynamic-component-helper";
import {CreateFxRateDialogComponent} from "./components/create-fx-rate-dialog/create-fx-rate-dialog.component";
import {AddFxRateReportComponent} from '@features/fx-rate/components/add-fx-rate-report/add-fx-rate-report.component';
import {FxRateViewReportComponent} from '@features/fx-rate/components/fx-rate-view-report/fx-rate-view-report.component';

// @dynamic
export class FxRateDynamicComponentHelper {
  static components: any;

  static create(): void {
  }
  public static init () {
    if (FxRateDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['CreateFxRateDialogComponent'] = CreateFxRateDialogComponent;
    components['AddFxRateReportComponent'] = AddFxRateReportComponent;
    components['FxRateViewReportComponent'] = FxRateViewReportComponent;
    FxRateDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    FxRateDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
